import React, { useState } from "react";
import { FileText, AlertCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./DocumentCards.scss";

const SalaryCard = ({ doc }) => {
    const { t, i18n } = useTranslation();
    const [showAlert, setShowAlert] = useState(false);

    const getMonthName = (monthNumber) => {
        if (!monthNumber) return "";
        const date = new Date(2024, monthNumber - 1);
        const locale = i18n.language === 'heb' ? "he-IL" : "en-US"; 
        return new Intl.DateTimeFormat(locale, { month: "long" }).format(date);
    };

    const showUnavailableAlert = () => {
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    return (
        <>
            <div className="document-card flex-wrap">
                <div className="document-info">
                    <div
                        className="document-icon"
                        style={{
                            color:
                                doc.monthly_overview_file_link ||
                                    doc.salary_file_link
                                    ? "#60BB46"
                                    : "#9ca3af",
                        }}
                    >
                        <FileText />
                    </div>

                    <div className="document-text">
                        <div className="document-date-salary">
                            {getMonthName(doc.month)} {doc.year}
                        </div>
                    </div>
                </div>


                <div className="salary-buttons">
                    <button
                        className={`salary-btn ${doc.monthly_overview_file_link
                            ? "active"
                            : "disabled"
                            }`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!doc.monthly_overview_file_link) {
                                showUnavailableAlert();
                                return;
                            }
                            window.open(
                                doc.monthly_overview_file_link,
                                "_blank"
                            );
                        }}
                    >
                        <FileText className="btn-icon" />
                        {t("view-monthly-report")}
                    </button>

                    <button
                        className={`salary-btn ${doc.salary_file_link
                            ? "active"
                            : "disabled"
                            }`}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!doc.salary_file_link) {
                                showUnavailableAlert();
                                return;
                            }
                            window.open(doc.salary_file_link, "_blank");
                        }}
                    >
                        <FileText className="btn-icon" />
                        {t("view-payslip")}
                    </button>
                </div>
            </div>

            {showAlert && (
                <div className="document-alert-wrapper">
                    <div className="document-alert"
                    >
                        <div className="document-alert-box">
                            <div className="alert-icon">
                                <AlertCircle />
                            </div>
                            <div className="alert-text">
                                <h3>{t('document-not-available')}</h3>
                                <p>{t('try-again-later')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SalaryCard;
